<template>
  <page content-class="admin-campaign-list">
      <!-- Top-Level Settings Bar -->
      <b-card no-body class="campaign-settings-menu bg-light px-4 pt-3 pb-2 mt-3">
        <div class="d-flex justify-content-between pb-1">
          <h3><strong>Messaging Settings</strong></h3>
          <div  class="d-flex justify-content-end align-items-center"
                v-if="hasGoogleEnabled || hasMicrosoftEnabled">
            <span class="text-primary font-weight-bold mr-4" style="width: 150px">
              Connect Providers
            </span>
            <span
              style="width: 150px"
              @click="$router.push({ name: 'EmailSignature' })"
            >
              Edit Email Signature
            </span>
          </div>
        </div>
      </b-card>
      <b-card body-class="p-4" class="mt-3">
        <b-row class="justify-content-center">
            <b-col cols="12" sm="12" xs="12">
                <h3>Connect Messaging Provider</h3>
                <p class="text-muted">Connect your provider to send engagement comms from campaigns.</p>
                <!-- Slack Button -->
                <b-btn
                  size="md"
                  class="px-4 py-3 mr-4"
                  v-if="hasSlackEnabled"
                  :variant="(providers || []).includes('slack') ? 'success' : 'outline-primary'"
                  :href="authLink('slack')"
                >
                    <font-awesome-icon class="mr-2" :icon="[ 'fab', 'slack' ]" size="lg"/>
                    Add to Slack
                </b-btn>
                <!-- Google Button -->
                <b-btn
                  size="md"
                  class="px-4 py-3 mr-4"
                  v-if="hasGoogleEnabled"
                  :variant="(providers || []).includes('gmail') ? 'success' : 'outline-primary'"
                  :href="authLink('google')"
                >
                    <font-awesome-icon class="mr-2" :icon="[ 'fab', 'google' ]" size="lg"/>
                    Gmail / GSuite
                </b-btn>
                <!-- Microsoft Button -->
                <b-btn
                  size="md"
                  class="px-4 py-3"
                  v-if="hasMicrosoftEnabled"
                  :variant="(providers || []).includes('microsoft') ? 'success' : 'outline-primary'"
                  :href="authLink('microsoft')"
                >
                    <font-awesome-icon class="mr-2" :icon="[ 'fab', 'windows' ]" size="lg"/>
                    Outlook / Teams
                </b-btn>
            </b-col>
        </b-row>
        <b-row class="mt-4" v-if="hasGoogleEnabled">
            <b-col cols="12">
                <p>The Real Links Gmail App’s use and transfer of information received from Google APIs to any other app will adhere to <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes" target="_blank">Google API Services User Data Policy</a>, including the Limited Use requirements.</p>
            </b-col>
        </b-row>
      </b-card>
    </page>
</template>

<script>
import AdvancedForm from '@src/components/AdvancedForm';
import Page from '@/components/campaign-admin/page';
import communicationChannelProviderMixin from '@src/mixins/communicationChannelProvider';
import { mapRoot } from '@src/mixins/root';

export default {
  components: {
    AdvancedForm,
    Page
  },
  data: () => ({
    form: {
      senderEmail: null,
      senderName: null,
      smtpLogin: null,
      smtpPassword: null,
      smtpServerAddress: null,
      smtpPort: null,
      imapLogin: null,
      imapPassword: null,
      imapServerAddress: null,
      imapPort: null
    },
  }),
  async mounted() {
    if (this.$route.query && this.$route.query.callback) {
      console.log({ query: this.$route.query });
      const { methods: { connectedCommunicationChannelProvider } } = communicationChannelProviderMixin;
      try {
        await connectedCommunicationChannelProvider.call(this);
        this.$notification({ message: 'Your account is successfully connected to your provider.', variant: 'success' });
        console.log({ user: this.user });
      } catch (error) {
        this.$notifyErr(error, { prepend: 'Failed to connect to your provider.' });
        console.log(error);
      }
    }
  },
  computed: {
    ...mapRoot([ 'user', 'company', 'isDemoSite' ]),
    providers() {
      if (this.user && this.user.state) {
        return Object.keys(this.user.state).filter(key => this.user.state[key] && [ 'slack', 'gmail', 'microsoft' ].includes(key));
      }
      return null;
    },
    sitePreferences() {
      const { sitePreferences } = this.company || {};
      return sitePreferences || {};
    },
    hasGoogleEnabled() {
      const { commsChannelsEnabled } = this.sitePreferences || {};
      return (commsChannelsEnabled || []).includes('google');
    },
    hasSlackEnabled() {
      const { commsChannelsEnabled } = this.sitePreferences || {};
      return (commsChannelsEnabled || []).includes('slack');
    },
    hasMicrosoftEnabled() {
      const { commsChannelsEnabled } = this.sitePreferences || {};
      return (commsChannelsEnabled || []).includes('microsoft');
    },
  },
  methods: {
    input() {
      console.log('input() has been executed.');
      console.log('Form', this.form);
    },
    authLink(provider) {
      if (![ 'microsoft', 'google', 'slack' ].includes(provider)) return;
      let scope = '';
      let userScope = '';
      // let advancedScope = '';
      if (provider === 'google') {
        scope = 'https://www.googleapis.com/auth/gmail.send';
      } else if (provider === 'slack') {
        scope = '';
        userScope = 'chat:write,im:write,im:read,users:read,users:read.email,channels:read,groups:read,mpim:read';
        // advancedScope = 'groups:history,im:history,mpim:history,mpim:read,groups:read';
      } else if (provider === 'microsoft') {
        // scope = 'Mail.Send ChannelMessage.Send User.ReadBasic.All Team.ReadBasic.All Channel.ReadBasic.All Chat.ReadWrite offline_access';
        scope = 'Mail.Send ChannelMessage.Send User.ReadBasic.All Team.ReadBasic.All Channel.ReadBasic.All Chat.ReadBasic ChatMessage.Send Chat.Create offline_access openid';
      }
      const redirectLink = `${window.location.origin}/campaign-admin/settings/email-setup?callback=${provider}`;
      const { authServiceOrigin } = this.$root;
      if (userScope) {
        return `${authServiceOrigin}/oauth2/${provider}?scope=${scope}&user_scope=${userScope}&redirect=${redirectLink}&access_type=offline`;
      }
      return `${authServiceOrigin}/oauth2/${provider}?scope=${scope}&redirect=${redirectLink}&access_type=offline`;
    }
  }
};
</script>

<style lang="scss">
  .referral-jam-event-settings {
      .event-logo {
          max-height: 30px;
          max-width: 200px;
      }
  }
  .campaign-settings-menu {
    div > span:hover {
      cursor: pointer;
      font-weight: 600;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/campaign-admin/EmailSetup.vue